import JoditReact from "jodit-react";

import "./style.css";
import { editorConfig, uploadImageButton } from "./helpers";

export const RichRext = ({ value, label, onBlur, onChange }: Props) => {
  uploadImageButton();

  return (
    <div className="flex-col space-y-1">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <JoditReact
        value={value}
        config={editorConfig}
        onBlur={onBlur}
        onChange={onChange}
      />
    </div>
  );
};

interface Props {
  value: string;
  label?: string;
  onChange?: (newContent: string) => void;
  onBlur?: (newContent: string) => void;
}
